// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"d2a84176da597361e739","655":"0e9d6f52213c3ff9f6f4"}[chunkId] + ".js";
};